import { ReactNode } from 'react';
import EmptyStateIcon from '@/components/assets/empty-state-icon.svg?react';

interface DefaultEmptyTableProps {
  children?: ReactNode;
}

/**
 * Default component to show when entity table is empty
 */
export const DefaultEmptyTable = ({ children }: DefaultEmptyTableProps) => {
  const defaultEmptyMsg = 'No results found';
  return (
    <div className="flex flex-col items-center justify-center py-16 text-muted-foreground h-fit">
      <EmptyStateIcon className="w-18 h-20 pb-4" />
      <div className="text-base">{children ?? defaultEmptyMsg}</div>
    </div>
  );
};
